import { useMemo } from 'react';
import { CSSObjectWithLabel, StylesConfig } from 'react-select';

const useCityChooserStyles = (styles: StylesConfig|undefined): StylesConfig => useMemo(() => {
  const stylesDefault = {
    option: (base: CSSObjectWithLabel): CSSObjectWithLabel => ({
      ...base,
      color: null,
      backgroundColor: null,
    }),
    control: (base: CSSObjectWithLabel): CSSObjectWithLabel => ({
      ...base,
      backgroundColor: null,
      boxShadow: null,
      borderWidth: null,
    }),
  };

  if (styles) {
    return { ...stylesDefault, ...styles };
  }

  return stylesDefault;
}, [styles]);

export { useCityChooserStyles };
